import React from 'react';
import { Grid, Paper } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import SubHeaderDetails from 'components/subHeaderDetails/SubHeaderDetails';
import CustomerEmergency from './CustomerEmergency';

function CustomerCarousel(props) {
  const emergencyContactsLength =
    props?.details?.EmergencyContacts?.length > 3 ||
    props?.details?.DriverProfile?.EmergencyContacts?.length > 3
      ? true
      : false;


  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="space-around"
      alignItems="flex-start"
      className="customerCarousel"
      sm={12}
      md={3.3}
    >
      <Grid sm={12} className="width100">
        {emergencyContactsLength ? (
          <Carousel navButtonsAlwaysInvisible>
            <Paper>
              <SubHeaderDetails
                details={props?.details}
                loader={props?.loader}
                type={props?.type}
                onSubmittBtn={props?.onSubmittBtn}
                editData={props.editData}
                editIconFalse={props?.editButton}
                onDelete={props?.onDelete}
              />
            </Paper>
            <Paper>
              <CustomerEmergency details={props?.details} first3={true} />
            </Paper>
            <Paper>
              <CustomerEmergency details={props?.details} last2={true} />
            </Paper>
          </Carousel>
        ) : props?.details?.EmergencyContacts?.length > 0 ||
          props?.details?.DriverProfile?.EmergencyContacts?.length > 0 ? (
          <Carousel navButtonsAlwaysInvisible>
            <Paper>
              <SubHeaderDetails
                details={props?.details}
                type={props?.type}
                onSubmittBtn={props?.onSubmittBtn}
                editData={props.editData}
                loader={props?.loader}
                editIconFalse={props?.editButton}
                onDelete={props?.onDelete}
              />
            </Paper>
            <Paper>
              <CustomerEmergency
                details={props?.details}
                first3={true}
                loader={props?.loader}
              />
            </Paper>
          </Carousel>
        ) : (
          <Paper>
            <SubHeaderDetails
              details={props?.details}
              type={props?.type}
              onSubmittBtn={props?.onSubmittBtn}
              editData={props.editData}
              loader={props?.loader}
              editIconFalse={props?.editButton}
              onDelete={props?.onDelete}
            />
          </Paper>
        )}
      </Grid>
    </Grid>
  );
}

export default CustomerCarousel;
